import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import { RequestRejectDto, RequestApprovalDto } from '../dto/employee-request.dto';


@Injectable()
export class EmployeeRequestNestApi {

  private service: string = '';
  private model: string = 'EmployeeRequests';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public addPersonal(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addPersonal';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approvePersonal(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approvePersonal';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public reject(payload: RequestRejectDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'reject';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addContact(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addContact';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveContact(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveContact';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addAddress(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addAddress';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveAddress(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveAddress';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addEmergency(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addEmergency';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveEmergency(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveEmergency';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addFamily(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addFamily';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveFamily(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveFamily';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addEducation(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addEducation';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveEducation(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveEducation';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addMedical(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addMedical';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveMedical(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveMedical';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public addExperience(payload): Observable<any> {
    const method: string = 'POST';
    const func: string = 'addExperience';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public approveExperience(payload: RequestApprovalDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'approveExperience';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

}




// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/employee-request.api.ts